import { rest, empresa } from "@/config";
import modalidades from "@/store/modalidades";
import { getTipoById } from "@/api/tipos";

const finalidades = Object.keys(modalidades);

export const Formatter = async (imovel, finalidade) => {
	imovel.finalidade = finalidade;
	imovel.tipo = await getTipoById(finalidade, imovel.tipo_id);

	let tipo_id = imovel.tipo_id;
	//let finalidade = imovel.finalidade;
	let modalidade = 'residencial';
	if (finalidade == 'venda') {
		if ([282,222].includes(tipo_id)) {
			modalidade = 'lancamentos';
		}
		modalidade = 'pronto';
	} else if (finalidade == 'aluguel' && [8,9,10,17,19,20,24,25,30,35,38,40,41,48,53].includes(tipo_id)) {
		modalidade = 'comercial';
	}

	
	
	let placa = imovel.placa;
	let tipo = imovel.tipo.titulo;
	let cidade = imovel.cidade;
	let bairro = imovel.bairro;
	let uf = imovel.uf;
	let titulo = [tipo, bairro, cidade, uf].join(" ").slugify();
	//return `imovel/${finalidade}/${placa}/${titulo}`;

	finalidade = finalidade == 'aluguel' ? 'alugar' : 'comprar';
	imovel.url = `${finalidade}/${modalidade}/${titulo}/${placa}`;
	/*
	let cidade = imovel.cidade.slugify();
	let bairro = imovel.bairro.slugify();
	let tipo = imovel.tipo.slug;

	if (imovel.finalidade == "aluguel") {
		let [origem, subcodigo] = imovel.placa
			.replace(/^([\a-z]+)(\d+)$/gim, "$1-$2")
			.split("-");

		
		imovel.url =
			document.baseURI +
			`imoveis/aluguel/${cidade}/${bairro}/${tipo}/${subcodigo}/${origem}`;
	} else {
		let placa = imovel.placa;
		imovel.url =
			document.baseURI +
			`imoveis/venda/${cidade}/${bairro}/${tipo}/${placa}`;
	}
	*/
	return imovel;
};

const Placas = finalidades.reduce((acc, finalidade) => {
	acc[finalidade] = Promise.all(
		modalidades[finalidade].map(({ id: modalidade }) => {
			let modalidade_url = modalidade;
			if (modalidade == 'lancamentos') {
				//modalidade_url = 'lancamentos-vila-rica';
			}
			return fetch(
				`${rest.endpoint}/${finalidade}/${modalidade_url}/imoveis.json?t=${Date.now()}`
			)
				.then(resp => resp.json())
				.then(placas => Object.values(placas))
				.then(placas => placas.map(({ placa }) => placa))
				.catch(console.error);
		})
	).then(resp =>
		resp.reduce((a, placas) => {
			return [...a, ...(placas||[])];
		}, [])
	);

	return acc;
}, {});

export const Aluguel = Placas.aluguel;
export const Venda = Placas.venda;

export const getAll = () =>
	Promise.all([Aluguel, Venda]).then(([aluguel, venda]) => ({
		aluguel,
		venda
	}));

export const getImovelByPlaca = (placa, finalidade) => {
	return fetch(
		`${rest.endpoint}/${finalidade}/imovel/${placa.toUpperCase()}.json?t=${Date.now()}`
	)
		.then(resp => resp.json())
		.then(imovel => Formatter(imovel, finalidade))
		.catch(err => {
			return null;
		});
};

export const getImoveisByCodigo = async codigo => {
	let imoveis = await Promise.all(
		finalidades.map(async finalidade => {
			let placas = await Placas[finalidade];
			placas = placas.filter(
				placa =>
					{
						try {
							return placa.replace(/\D/gim, "") == `${codigo}`.replace(/\D/gim, "")

						} catch (err) {
							
							return false;
						}
					}
			);
			return await Promise.all(
				placas.map(placa => getImovelByPlaca(placa, finalidade))
			);
		})
	); 	

	imoveis = imoveis.reduce((acc, imoveis) => {
		return [...acc, ...imoveis];
	}, []);

	imoveis = imoveis.filter(imovel => imovel !== null).reduce((acc, imovel) => {
		acc[imovel.placa] = imovel;
		return acc;
	}, {})
	imoveis = Object.keys(imoveis).map(key => imoveis[key]);

	return imoveis;
};

export default {
	Aluguel,
	Venda,
	getAll,
	getImoveisByCodigo,
	getImovelByPlaca
};
